var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Image)?_c('div',{staticClass:"partner",style:({ 'background-image': 'url('+ require('../assets/'+_vm.Image+'') +')'})}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }